import * as React from "react"
import { Link } from "gatsby"
import { Link as LinkScroll, animateScroll as scroll } from "react-scroll";
import { StaticImage } from "gatsby-plugin-image";
import Layout from "../components/layout"
import SEO from "../components/seo"
import Form from "../components/contactform"
import BG from "../components/background"



const ServicePage = () => (
  <Layout>
    <SEO 
      title="WCL"
      description="descriptionです"
    />
    <div className="single service">
      <div id="service01" className="section">
        <h2>WEB
          <span>ホームページ制作</span>
        </h2>
        <p>
          HTMLやJavaScriptなどお客様のご要望に合った制作方法で作成いたします。
          お客様で更新可能したい場合はWordPress、ランディングページ（LP）などはHTMLやJavaScriptなどを使用します。
          デザインテンプレートなどを利用することで、費用をなるべく抑えて制作することも可能ですので、お気軽にご相談ください。
        </p>
        {/* <p>
          使用技術：
          HTML/CSS, JavaScript, React, Vueなど
        </p> */}
  
        <h3>制作実績</h3>
        <div className="works">
            <div className="item">
              <StaticImage
                src="../images/service/web-wcl.jpg"
                alt="works WEB"
                placeholder="blurred"
              />
              <h4>本サイト</h4>
              <p>Role: <br />
              UI/UXデザイン, コーディング(React/Gatsby.js)</p>
            </div>
            {/* <div className="item">
              <StaticImage
                src="../images/service/web-rakuni.jpg"
                alt="works WEB"
                placeholder="blurred"
              />
              <a href="https://rakuni.me/" className="underline" target="_blank" >https://rakuni.me/</a>
              <h4>Rakuni<span> - スマートフォンケースサイト</span></h4>
              <p>Role: <br />
              コーディング(WordPress)</p>
            </div> */}
        </div>
  
  
      </div>
  
      <div id="service02" className="section">
        <h2>EC
          <span>オンラインショップ制作</span>
        </h2>
        <p>
        ウェブサイト、ホームページ制作のみならず、オンラインショップが一般的になってきています。
        BASEやStoresなどのインスタントカートの導入や、目新しいShopifyなどの導入補助からASP系のECシステムの構築まで、ワンストップでお手伝いさせていただきます。
        </p>
  
        <h3>制作実績</h3>
        <div className="works">
            <div className="item">
              <StaticImage
                src="../images/service/s02.jpg"
                alt="works EC"
                placeholder="blurred"
              />
              <a href="https://rulers-tacorice.com/" className="underline" target="_blank" >https://rulers-tacorice.com/</a>
              <h4>RuLer's Tacorice<span> - タコライスショップ</span></h4>
              <p>Role: <br />
              デザイン, コーディング(WordPress), ECショップ設定</p>
            </div>
            <div className="item">
              <StaticImage
                src="../images/service/ec-happymore.jpg"
                alt="works EC"
                placeholder="blurred"
              />
              <a href="https://happymore.theshop.jp/" className="underline" target="_blank" >https://happymore.theshop.jp/</a>
              <h4>ハッピーモア市場<span> - 沖縄ファーマーズマーケット</span></h4>
              <p>Role: <br />
              コーディング(BASE), ECショップ設定</p>
            </div>
        </div>
  
      </div>
  
      <div id="service03" className="section">
        <h2>DX
          <span>デジタルトランスフォーメーション施策</span>
        </h2>
        <p>
        これってデジタル化できないかな。ちょっとしたことを便利にしたい。新しい技術を導入したい。<br />
        日常のちょっとしたことで、そんな場面ありませんか？<br />
        私たちがそのお手伝いをさせていただきます。あなたの身近なこと、あなたのお仕事の新しい展開を一緒に考えていきましょう。
        </p>
        
  
  
        <h3>制作実績</h3>
        <div className="works">
            <div className="item">
              <StaticImage
                src="../images/service/s03.jpg"
                alt="works DX"
                placeholder="blurred"
              />
              <h4>個人向けスマートホーム用ウェブアプリ</h4>
              <p>Role: <br />
              スマートホーム設計, UI/UXデザイン, コーディング(React/Next.js), システム開発(Python/Django)</p>
            </div>
        </div>
  
      </div>
  

      <div id="flow" className="section flow">

        <h3>ご依頼からの流れ</h3>

        <div className="flow-item">
          <h4>
            step<span>1</span>
            <span className="jpn">相談</span>
          </h4>
          <p>
          まずは気軽にお問い合わせよりご連絡ください。<br />
          ご相談内容やご予算、スケジュール感などを伺わせていただきます。ご相談については費用はいただきません。
          気になったことは、なんでもご相談ください。<br />
          何度かメールでのやりとりを行ったあと、zoomなどでオンラインで打ち合わせさせていただく場合もございます。<br />
          </p>
        </div>
        <div className="flow-item">
          <h4>
            step<span>2</span>
            <span className="jpn">構成 / 整理</span>
          </h4>
          <p>
            お客様のご要望を伺いながら、ホームページ、オンラインショップのサイト構成ワイヤーフレームを作り出していきます。<br />
            それ以外もある場合は、最終的な制作物の整理をさせていただきます。<br />
            この時点でお話を進めながら、お客様でお持ちの素材（写真や動画、ロゴのデータなど）を提供していただきます。
          </p>
        </div>
        <div className="flow-item">
          <h4>
            step<span>3</span>
            <span className="jpn">デザイン</span>
          </h4>
          <p>
          制作物のデザインを行います。できるだけお客様のご要望のデザインに沿わせていただきます。
          </p>
        </div>
        <div className="flow-item">
          <h4>
            step<span>4</span>
            <span className="jpn">実装</span>
          </h4>
          <p>
          実際にプログラミングをして構築していきます。また、サーバーなどのインフラ構築など含め対応していきます。
          </p>
        </div>
        <div className="flow-item">
          <h4>
            step<span>5</span>
            <span className="jpn">確認 / 公開</span>
          </h4>
          <p>
          実装したものを確認していただきます。<br />
          問題なければ公開/納品させていただきます。
          </p>
        </div>
        
        <p className="center">まずは、下記フォームよりご相談ください。</p>

  
      </div>
  


      <div id="contact" className="contact section">
        <h2>Contact</h2>
        <Form />
      </div>
    </div>
    
    <BG />

  </Layout>

)

export default ServicePage
